// extracted by mini-css-extract-plugin
var _1 = "PortalHeader_helpQuestionIcon__U3pf4";
var _2 = "PortalHeader_noOutline__ODZ5M";
export { _1 as "helpQuestionIcon", _2 as "noOutline" }
